import React, { useState } from 'react'
import useStyles from './style'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { Paper } from "@material-ui/core";
import ModelWithTableViewer from '../../CreateStepperView/StepLevelBlocks/AddDocuments/model'

const UploadCardViewer = (props) => {
    const { block, isEditable, blockState, onSaveClickV2, enableWorkflow } = props
    const { chartUniqueId, chartData } = props.data
    const [open, setOpen] = useState(false);
    const classes = useStyles()
    const handleOpen = () => { setOpen(true); setKey(block.dataModel || selectedStep.dataModel) };
    const handleCloseModel = () => setOpen(false);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [selectedOptions, setSelectedOptions] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOptions, setMenuOptions] = useState([]);
    const [keyVal, setKey] = useState("");

    const handleSaveDocumentsOutside = (newLinkedReferenceDocument, documentId) => {
        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${chartUniqueId}_documentsfromIds`]
        })
        props.onSaveClickV2({
            ...blockState,
            linkedReferenceDocuments: newLinkedReferenceDocument
        });
    }

    const isButtonEnabled = props.enableWorkflow && blockState?.['status'] !== 'Rejected' && blockState?.['status'] !== 'Completed' && blockState?.workflow && blockState?.workflow?.currentRespondent?.id === props.members?._id;

    return (
        <div className={classes.sectionPadding}>
            <div className={classes.banner}>
                <img src={block?.bannerImage} className={classes.bannerImg} />
                <div className={classes.bannerRow}>
                    <Button
                        variant="contained"
                        className={classes.bannerBtn}
                        onClick={() => { handleOpen() }}
                        style={{ backgroundColor: !isButtonEnabled ? 'transparent' : 'transparent', cursor: !isButtonEnabled ? 'pointer' : 'not-allowed' }}
                        disabled={!isButtonEnabled}
                    >
                        {block?.buttonText}
                    </Button>   
                    <div className={classes.bannerTextWrap}>
                        <Typography className={classes.bannerSubHeading}>
                            {block?.subHeading}
                        </Typography>
                        <Typography className={classes.bannerTopHeading}>
                            {block?.topHeading}
                        </Typography>
                    </div>
                </div>
            </div>
            {
                open && (
                    <ModelWithTableViewer
                        {...props}
                        open={open}
                        handleCloseModel={handleCloseModel}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        keyVal={keyVal}
                        chartUniqueId={chartUniqueId}
                        block={block}
                        parentBlockState={props.blockState}
                        isCallingoutside={true}
                        handleSaveDocumentsOutside={handleSaveDocumentsOutside}
                    />
                )
            }
        </div>

    )
}

export default UploadCardViewer